export const state = () => ({
  reload_at: null,
})
export const mutations = {
  updateReload(state) {
    state.reload_at = Date.now()
  },
}
